import { traverseHtmlElements } from './traverseHtmlElements';

const ALLOWED_EMPTY_ELEMENTS = new Set([
  'BR',
  'IMG',
  'TD',
  'TH',
]);

const isEmpty = (element: Element): boolean => {
  return !ALLOWED_EMPTY_ELEMENTS.has(element.nodeName) && !element.innerHTML.trim();
};

/**
 * Recursively removes an empty element and, if its removal makes the parent empty,
 * also removes the parent. This ensures that after stripping an orphaned node,
 * any now-empty containers are also cleaned up.
 */
const removeIfEmpty = (element: Element): void => {
  if (isEmpty(element)) {
    const { parentElement } = element;

    element.remove();

    if (parentElement) {
      removeIfEmpty(parentElement);
    }
  }
};

/** Remove empty elements from rootNode. Allowed empty elements: BR, IMG. */
export const cleanHtmlEmptyElements = (elementNode: Node): void => {
  traverseHtmlElements(elementNode, (element) => {
    removeIfEmpty(element);

    return true;
  });
};
